import AdSourceHeaderContent from 'components/signUpFunnel/Tempo/AdSourceHeaderContent';
import ImageSection from 'components/signUpFunnel/Tempo/ImageSection';
import useQuery from 'hooks/useQuery';

const TempoHeader = () => {
  const { isQueryParamTrue: isAdSource } = useQuery('source', 'ad');
  const { isQueryParamTrue: isSharapova } = useQuery('ms', 'true');

  if (!isAdSource) {
    return null;
  }

  if (isAdSource) {
    return (
      <div className="relative">
        <AdSourceHeaderContent isSharapova={isSharapova} />
        <ImageSection variant={isSharapova ? 'sharapova' : 'adSource'} />
      </div>
    );
  }
};

export default TempoHeader;
